// extracted by mini-css-extract-plugin
export var carousel = "Carousel-module--carousel--3APrt";
export var prev = "Carousel-module--prev--1vqA4";
export var next = "Carousel-module--next--dXR5c";
export var carret = "Carousel-module--carret--3crty";
export var item = "Carousel-module--item--1wwnI";
export var dotsContainer = "Carousel-module--dots-container--H0vbg";
export var dot = "Carousel-module--dot--2xi1M";
export var active = "Carousel-module--active--1-YTl";
export var fade = "Carousel-module--fade--vb1yw";